import React from 'react'

const SupplierReceivingAudit = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Supplier Receiving Audit</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Product & Stock Verification</li>
            <li className="breadcrumb-item active">Supplier Receiving Audit</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Supplier Receiving Audit</h5>
                <p>Review and audit all supplier receiving transactions.</p>
                {/* Add supplier receiving audit table/component here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SupplierReceivingAudit

